import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, getUID } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  "/login",
  "/403",
  "/404",
  "/lost-password",
  "/forgot/:token",
  "/login/two-factor-authentication/:uid",
  "/login/sms-authentication/:uid"
]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);
  const roles = to.meta.roles;
  // determine whether the user has logged in
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      const hasUID = getUID();
      const { role, flag_compliancework, is_whitelabel } = await store.dispatch(
        "user/getInfo"
      );

      if (hasUID) {
        if (roles && !roles.includes(role)) {
          next(`/404`);
          NProgress.done();
        } else if (
          ["/firewall"].includes(to.matched[0].path) &&
          !flag_compliancework
        ) {
          next(`/404`);
          NProgress.done();
        } else if (
          ["/introducer"].includes(to.matched[0].path) &&
          is_whitelabel
        ) {
          next(`/404`);
          NProgress.done();
        } else {
          next();
        }
      } else {
        await store.dispatch("user/resetToken");
        next(`/login`);
        NProgress.done();
      }
    }
  } else {
    /* has no token*/

    if (whiteList.includes(to.matched[0].path)) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
